/* eslint-disable no-nested-ternary */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import Link from 'next/link';

import { titleCase } from '../../utils/formatting';
import styles from './rankingList.module.scss';
import RatingTrend from '../SubRating/ratingTrend';
import { getPlayerGradClassNameAbbreviation } from '../../utils';
import Img from '../Img';

class RankedPlayerItem extends React.Component {
    render() {
        const nationalFlag = this.props.nationality ? `/img/flags/${this.props.nationality.toLowerCase()}.svg` : '';
        const playerCollegeClubProfilePhotoUrl = this.props.playerCollegeClubProfilePhotoUrl ? `/v1/club/${this.props.playerCollegeClubProfilePhotoUrl}?variant=icon` : null;
        const playerHighSchoolClubProfilePhotoUrl = this.props.playerHighSchoolClubProfilePhotoUrl ? `/v1/club/${this.props.playerHighSchoolClubProfilePhotoUrl}?variant=icon` : null;
        const { playerLevel } = this.props;
        const descriptionItems = [];
        if (playerLevel && playerLevel.toLowerCase() === 'college') {
            if (this.props.playerCollegeDetails) {
                const playerGradClassNameAbbreviation = getPlayerGradClassNameAbbreviation(this.props.playerCollegeDetails.gradClassName);
                if (playerGradClassNameAbbreviation) {
                    descriptionItems.push(playerGradClassNameAbbreviation.toUpperCase());
                }
            }
        } if (playerLevel && playerLevel.toLowerCase() === 'highschool') {
            if (this.props.playerHighSchool) {
                descriptionItems.push(this.props.playerHighSchool.stateAbbr || this.props.playerHighSchool.stateName);
                descriptionItems.push(this.props.playerHighSchool.shortName || this.props.playerHighSchool.name);
            }
        } else {
            if (this.props.gender === 'Male') {
                descriptionItems.push('M');
            }
            if (this.props.gender === 'Female') {
                descriptionItems.push('F');
            }
        }
        if (this.props.nationality) {
            descriptionItems.push(this.props.nationality);
        }
        const description = descriptionItems.filter((el) => { return el; }).join(' \u00B7 ');

        const { rating, ranking } = this.props;

        return (
            <div className={`${styles.rankItem}`}>
                {!this.props.loading
                    ? (
                        <div className={`row ${styles.playerRow}`}>
                            <div className={`col-1 ${styles.rankItemColumn} ${styles.rankColumn}`}>
                                {ranking}
                            </div>
                            <div className={`col-1 ${styles.nationalFlagContainer}`}>
                                {playerLevel && playerLevel.toLowerCase() === 'college' && playerCollegeClubProfilePhotoUrl && this.props.nationality ? (
                                    <Link href={`/colleges/${this.props.playerCollegeClubId}`}>
                                        <Img src={playerCollegeClubProfilePhotoUrl} className={styles.nationalFlag} alt={this.props.nationality} />
                                    </Link>
                                ) : (playerLevel && playerLevel.toLowerCase() === 'highschool' && playerHighSchoolClubProfilePhotoUrl && this.props.nationality ? (
                                    <Link href={`/schools/${this.props.playerHighSchoolClubId}`}>
                                        <Img src={playerHighSchoolClubProfilePhotoUrl} className={styles.nationalFlag} alt={this.props.nationality} />
                                    </Link>
                                ) : (
                                    this.props.nationality && (
                                        <Img src={nationalFlag} className={styles.nationalFlag} alt={this.props.nationality} />
                                    )
                                ))}
                            </div>
                            <div className={`col-5 col-sm-5 ${styles.rankItemColumn} jcfs`}>
                                <div className={styles.nameWrapper}>
                                    <div className={styles.name}>
                                        <span className="d-none d-md-flex">{titleCase(this.props.displayName)}</span>
                                        <span className="d-flex d-md-none">{this.props.firstName.charAt(0)}. {titleCase(this.props.lastName)}</span>
                                    </div>
                                    <div className={styles.description}>
                                        {description}
                                    </div>
                                </div>
                            </div>
                            <div className={`col-2 ${this.props.showThirdPartyRanking ? 'col-sm-1' : 'col-sm-2'} text-center ${styles.rankItemColumn}`}>
                                {rating.toFixed(2)}
                            </div>
                            <div className={`col-3 ${this.props.showThirdPartyRanking ? 'col-sm-2' : 'col-sm-3'} text-center text-nowrap ${styles.rankItemColumn}`}>
                                <RatingTrend {...this.props.threeMonthRatingChangeDetails} />
                            </div>
                            <div className={`col-1 d-none ${this.props.showThirdPartyRanking ? 'd-sm-flex' : ''} text-center text-nowrap ${styles.rankItemColumn}`}>
                                {this.props.thirdPartyRanking ? this.props.thirdPartyRanking.rank : '--'}
                            </div>
                            <div className={`col-1 text-center ${styles.rankItemColumn} ${styles.arrowColumn} d-none ${this.props.showThirdPartyRanking ? 'd-sm-flex' : ''}`}>
                                <span>→</span>
                            </div>
                        </div>
                    ) : (
                        <div className={`row ${styles.playerRow}`}>
                            <div className={`col-12 ${styles.rankItemColumn}`}>
                                <div className={styles.loading}>
                                    <Img src="/img/loading/ranked-player-loader.gif" alt="loading" />
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

export default RankedPlayerItem;
